export default __webpack_public_path__ + "static/media/TOYOTA01.f4bc2007.png";